import { EntryErrorListField } from '../../../../types/types';

// Builds the value returned for a selected entry error list row: values of
// all fields marked return=true concatenated with '|'. Falls back to the
// first field when no field is marked.
export const getEntryListReturnValue = (
  row: (string | number | null)[],
  fields: EntryErrorListField[]
): string => {
  const returnIndexes = fields
    .map((field, index) => (field.return ? index : -1))
    .filter((index) => index !== -1);
  const indexes = returnIndexes.length > 0 ? returnIndexes : [0];

  return indexes.map((index) => String(row[index] ?? '')).join('|');
};
